import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let app;
let analytics;

export function getFirebase() {
  if (!app) {
    app = getApps()[0] || initializeApp(firebaseConfig);

    if (typeof window !== 'undefined') {
      if (process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
        try {
          if (process.env.NODE_ENV === 'development') {
            window.self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
          }
          initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
            isTokenAutoRefreshEnabled: true,
          });
        } catch (e) {
          // already initialized
        }
      }

      try {
        analytics = getAnalytics(app);
      } catch (e) {}
    }
  }
  return { app, analytics };
}

export async function submitContactForm(data) {
  const { app } = getFirebase();
  try {
    const fn = httpsCallable(getFunctions(app, 'us-central1'), 'submitContactForm');
    const result = await fn(data);
    console.log('✅ Contact form sent');
    return result.data;
  } catch (error) {
    console.error('❌ Contact form error:', error.code, error.message);
    return { success: false, error: error.message };
  }
}

export async function subscribeNewsletter(email) {
  const { app } = getFirebase();
  try {
    const fn = httpsCallable(getFunctions(app, 'us-central1'), 'subscribeNewsletter');
    const result = await fn({ email });
    console.log('✅ Newsletter subscribed');
    return result.data;
  } catch (error) {
    console.error('❌ Newsletter error:', error.code, error.message);
    return { success: false, error: error.message };
  }
}
